/* How a giveaway winner is named in public.
 *
 * "John D." — enough to recognise yourself, or to believe a real person won, without
 * publishing a member's full name to everybody else on the platform.
 *
 * It replaces initials-only ("JD.", and "D." whenever a first name was missing),
 * which was too little to read as a person at all.
 *
 * Shared because two member-portal cards show this and they must not drift into
 * naming the same winner differently.
 */
export const winnerDisplayName = (
  firstName?: string | null,
  lastName?: string | null,
  fallback?: string | null
): string => {
  const first = String(firstName || '').trim();
  const last = String(lastName || '').trim();

  // Only the first letter is forced. The rest is left as they typed it, so
  // "McDonald" and "O'Brien" survive.
  const givenName = first ? first.charAt(0).toUpperCase() + first.slice(1) : '';
  const initial = last ? `${last.charAt(0).toUpperCase()}.` : '';

  const name = [givenName, initial].filter(Boolean).join(' ');
  // No name on the account at all — better their username than a bare full stop,
  // which is what the old initials logic produced.
  return name || String(fallback || '').trim() || 'A member';
};
